const LanguageCode = "ta";
document.body.classList.add(LanguageCode + "-body");
const Globals = {
  LanguageCode : "ta",
  language_based_api:"https://ws-n.webdunia.com/json/page?lang=" + LanguageCode + "&url=",
  Desktop_language_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=ta&menuType=NavigationMenu&menuId=7",
  Desktop_header_based_api: "https://api-en.webdunia.com/api/v3/get-menu-by-Id?lang=ta&menuType=NavigationMenu&menuId=7",
  Desktop_footer_based_api:"https://api-en.webdunia.com/api/v3/get-menu-by-id?lang=ta&menuType=FooterMenu&menuId=7",
};
export default Globals;
